import { routes } from '@/app/routing/router'
import { UpdatePageView } from './view'

const currentRoute = routes.update

const UpdatePageRoute = {
  view: UpdatePageView,
  route: currentRoute,
}

export { currentRoute, UpdatePageRoute }
